import React from "react";
import "./footer.css";
import "../Navbar/navbar.css";
import Logo from "../atrimages/logo.jpg";
import {
  FaFacebook,
  FaInstagram,
  FaSnapchat,
  FaYoutube,
  FaMapMarkedAlt,
} from "react-icons/fa";
import Timer from "../Timer/Timer";
import { Link } from "react-router-dom";
// import PortFolio from "../aothers/portfolio comp/portfolio";

export default function Footer() {
  return (
    <div className="bfooter">
      <footer>
        <div className="frow">
          <div className="fcol left">
            <div className="leftlogo">
              <img src={Logo} alt="logo" />
            </div>
            <div className="fcontent">
              <h1>ATRI BOREALIS-{new Date().getFullYear()}</h1>
              <p style={{ fontSize: "14px" }}>
                <b>BOREALIS</b> is the ATRI’s technical and Cultural festival
                that is organized on a grand scale.
              </p>
              <span style={{ fontSize: "14px" }}>
                <FaMapMarkedAlt style={{ fontSize: "25px" }} /> Aurora's
                Technological and Research Institute , Parvathapur, Uppal ,
                Hyderabad, Telangana-500039
              </span>
            </div>
            <br />
            <div className="ficons">
              <h3>Follow Us: </h3>
              <a href="https://www.facebook.com/atrihyd" target="_blank">
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/sacatriofficial/?hl=en"
                target="_blank"
              >
                <FaInstagram />
              </a>
              <a href="/" target="_blank">
                <FaSnapchat />
              </a>
              <a
                href="https://www.youtube.com/watch?v=XngU09gMpvc"
                target="_blank"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
          <div className="fcol center">
            <h3>Our Sites Info</h3>
            <ul className="clinks">
              <a href="https://www.atri.edu.in/">ATRI Blog</a>
              <Link to="/ourteam">Our Team</Link>
              <a href="/">Dashbaord</a>
              <a href="https://www.atri.edu.in/festivities_events.php">
                Events
              </a>
              <Link href="/contact">Contact</Link>
            </ul>
          </div>
          <div className="fcol right">
            <h3>Helpful Links</h3>
            <ul className="clinks">
              <Link to="/">Services</Link>
              <Link to="/">Supports</Link>
              <Link to="/">Terms & Conditions</Link>
              <Link to="/">Privacy & Policy</Link>
            </ul>
            <h5>Count Down :)</h5>
            <span>
              <Timer />
            </span>
          </div>
          <br />
        </div>
        <hr
          style={{
            width: "100%",
            borderTop: "5px solid white",
            margin: "0",
          }}
        />
        <div className="copyright">
          <div className="fcleft">
            &copy; ATRI BOREALIS - {new Date().getFullYear()}
          </div>
          <div className="fccenter">
            &copy; Designed by -{" "}
            <a href="https://www.instagram.com/parrot.rakhy/">
              @Chilukala.Rakesh
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link
              to="cr"
              element={
                "<h1>The page still updating stage .... Not done yet!<h1></h1>"
              }
            >
              PortFolio
            </Link>
          </div>
          <div className="fcright"> ATRI,Parvathapoor - Hyderabad</div>
        </div>
      </footer>
    </div>
  );
}
